import { createSelector } from "reselect";

const artisansStateSelector = (state) => state.artisanFollowerList;
const selectById = (state, itemId) => itemId;

export const artisansSelector = createSelector(
  [artisansStateSelector],
  (artisans) => artisans.items
);

export const artisansAsLabelAndValueSelector = createSelector(
  [artisansSelector],
  (artisans) =>
    artisans.map(({ _id, firstName, lastName, logo, email}) => ({
      _id: _id,
       firstName,
       lastName,
       logo,
       email
    }))
);

// export const artisanByIdSelector = createSelector(
//   [artisansSelector, selectById],
//   (artisans, _id) => {
//     const product = artisans.find((item) => _id === item._id);
//     if (!product) return null;
//     return product;
//   }
// );

/**
 * Misc
 */

export const artisansIsLoadingSelector = createSelector(
  [artisansStateSelector],
  (artisans) => artisans.isLoading
);

export const artisansCountSelector = createSelector(
  [artisansStateSelector],
  (artisans) => artisans.count
);

export const searchValueSelector = createSelector(
  [artisansStateSelector],
  (artisans) => artisans.searchValue
);
